import { render } from "./Parameter.vue?vue&type=template&id=f3496df4"
import script from "./Parameter.vue?vue&type=script&lang=js"
export * from "./Parameter.vue?vue&type=script&lang=js"

import "./Parameter.vue?vue&type=style&index=0&id=f3496df4&lang=sass"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/loaders/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QTooltip,QChip,QDialog,QCard,QCardSection,QSpace,QCardActions});qInstall(script, 'directives', {ClosePopup});
